<template>
    <div class="index">
        <div class="header">
            <div class="inner">
                <div class="companyName">{{ CONSTANT.WELCOME_MSG }}</div>
                <div class="btn-wrap">
                    <p
                        :class="{ active: item.active }"
                        v-for="(item, index) in btns"
                        :key="index"
                        @click="btnClick(item)"
                    >
                        {{ item.name }}
                    </p>
                </div>
            </div>
        </div>
        <div class="menu">
            <div class="logo">
                <img src="@/assets/images/logo.png" alt="" />
            </div>
            <div class="menu-list" :class="{'menu-list_en': select_language === 'en'}">
                <div class="menu-item" v-for="item in menuData" :key="item.path" @click="handleClick(item)">
                    <a :href="'#' + item.path">{{ item.name }}</a>
                </div>
            </div>
        </div>
        <div class="banner">
            <div class="banner-wrap">
                <div class="content">{{ CONSTANT.SLOGON_LINE1 }}<br />{{ CONSTANT.SLOGON_LINE2 }}</div>
            </div>
        </div>
        <div id="service" class="service-area">
            <div class="title">{{ CONSTANT.SCOPE_OF_SERVICES.section_title }}</div>
            <div class="content">
                {{ CONSTANT.SCOPE_OF_SERVICES.desc }}
            </div>
            <div class="service-sub">
                <div class="sub-item">
                    <div class="item-icon"></div>
                    <div class="item-title">{{ CONSTANT.SCOPE_OF_SERVICES.acquire_intellectual_property.title }}</div>
                    <div class="item-content">
                        <p
                            v-for="(item, index) in CONSTANT.SCOPE_OF_SERVICES.acquire_intellectual_property
                                .content_lines"
                            :key="index"
                        >
                            {{ item }}
                        </p>
                    </div>
                </div>
                <div class="sub-item">
                    <div class="item-icon"></div>
                    <div class="item-title">{{ CONSTANT.SCOPE_OF_SERVICES.dispute_resolution.title }}</div>
                    <div class="item-content">
                        <p
                            v-for="(item, index) in CONSTANT.SCOPE_OF_SERVICES.dispute_resolution.content_lines"
                            :key="index"
                        >
                            {{ item }}
                        </p>
                    </div>
                </div>
                <div class="sub-item">
                    <div class="item-icon"></div>
                    <div class="item-title">{{ CONSTANT.SCOPE_OF_SERVICES.business_consulting_services.title }}</div>
                    <div class="item-content">
                        <p
                            v-for="(item, index) in CONSTANT.SCOPE_OF_SERVICES.business_consulting_services
                                .content_lines"
                            :key="index"
                        >
                            {{ item }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div id="experience" class="experience-area">
            <div class="title">{{ CONSTANT.EXCEPTIONNAL_INDUSTRY_EXPERIENCE.section_title }}</div>
            <div class="content">
                {{ CONSTANT.EXCEPTIONNAL_INDUSTRY_EXPERIENCE.desc }}
            </div>
            <div class="experience-sub">
                <div class="company-wrap">
                    <div class="left-btn"><img @click="onSlidePrev" src="@/assets/images/arrow-left.png" alt="" /></div>
                    <swiper :options="experienceSwiperOption" ref="mySwiper2" id="mySwiper2">
                        <swiper-slide
                            class="swiper_slide_item"
                            v-for="(item, index) in CONSTANT.COMPANY_INFO"
                            :key="index"
                        >
                            <div class="com-item" v-for="comItem in item" :key="comItem.name">
                                <img :src="comItem.image" alt="" class="img" />
                                <img :src="comItem.logo" alt="" class="icon" />
                                <div class="com-name">
                                    {{ comItem.name }}
                                </div>
                                <div class="com-content">
                                    {{ comItem.desc }}
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="right-btn">
                        <img @click="onSlideNext" src="@/assets/images/arrow-right.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div id="aboutUs" class="us-area">
            <div class="us-wrap">
                <img class="left" src="@/assets/images/us.png" alt="" />
                <div class="right">
                    <p class="title">{{ CONSTANT.ABOUT_US.section_title }}</p>
                    <p class="content" v-for="(item, index) in CONSTANT.ABOUT_US.content_lines" :key="index">
                        {{ item }}
                    </p>

                    <p class="content">{{ CONSTANT.ABOUT_US.content_team }}</p>
                </div>
            </div>
        </div>
        <div id="team" class="team-area">
            <div class="title">{{ CONSTANT.MENU_DATA.find(x => x.path === 'team').name }}</div>
            <div class="team-wrap">
                <div>
                    <swiper :options="teamSwiperOption" ref="mySwiper" id="mySwiper">
                        <!--必须的组件-->
                        <!--每页幻灯片使用swiper-slide标签-->
                        <!--幻灯片组件生成的标签自带.swiper-slide的类名，但单类名选择器设置的部分css(如宽高)将被覆盖-->
                        <swiper-slide
                            class="swiper_slide_item"
                            v-for="(item, index) in CONSTANT.TEAM_INFO"
                            :key="index"
                        >
                            <div class="slide-item-wrap">
                                <div class="left">
                                    <img :src="item.image" alt="" />
                                </div>
                                <div class="right">
                                    <p class="name">{{ item.name }}</p>
                                    <p class="desc" :class="{ desc2: !item.desc2 }">{{ item.desc1 }}</p>
                                    <p class="desc" :class="{ desc2: item.desc2 }" v-if="item.desc2">
                                        {{ item.desc2 }}
                                    </p>
                                    <p class="position" v-for="(item2, idx) in item.position" :key="idx">
                                        {{ item2 }}
                                    </p>
                                </div>
                            </div>
                        </swiper-slide>
                        <!--分页器-->
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
            </div>
        </div>
        <div id="contact" class="contact-area">
            <div class="contact-wrap">
                <div class="left">
                    <!-- <p class="p-1">Hello! are you ready?</p> -->
                    <p class="p-2">{{ CONSTANT.COMPANY_ADDRESS.hello_msg }}</p>
                    <p class="p-3">{{ CONSTANT.COMPANY_ADDRESS.section_title }}</p>
                    <p class="p-3" v-for="(item, index) in CONSTANT.COMPANY_ADDRESS.content_lines" :key="index">
                        {{ item }}
                    </p>
                </div>
                <div class="right">
                    <div class="form">
                        <div class="form-row">
                            <div class="form-item">
                                <p class="title">{{ CONSTANT.COMPANY_ADDRESS.name }}</p>
                                <div class="input"><input type="text" v-model.trim="params.name" /></div>
                            </div>
                            <div class="form-item ml-20">
                                <p class="title">E-mail</p>
                                <div class="input"><input type="text" v-model.trim="params.email" /></div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-item">
                                <p class="title">{{ CONSTANT.COMPANY_ADDRESS.mobile }}</p>
                                <div class="input"><input type="text" v-model.trim="params.mobile" /></div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-item">
                                <p class="title">{{ CONSTANT.COMPANY_ADDRESS.content }}</p>
                                <div class="input">
                                    <textarea type="text" v-model.trim="params.desc"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="btn" @click="sendEmail">{{ CONSTANT.COMPANY_ADDRESS.submit_btn }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="hire" class="hire-area" v-if="select_language === 'zh'">
            <div class="hire-wrap">
                <div class="title">{{ CONSTANT.RECRUITMENT_INFORMATION.section_title }}</div>
                <div class="content">
                    <div class="item">
                        <p class="name">{{ CONSTANT.RECRUITMENT_INFORMATION.name }}</p>
                        <p class="desc mb-30">{{ CONSTANT.RECRUITMENT_INFORMATION.desc }}</p>
                        <p
                            class="arrow"
                            :class="{ 'arrow-up': showArrowUp1 }"
                            @click="showArrowUp1 = !showArrowUp1"
                        ></p>
                        <div class="detail-wrap" v-show="showArrowUp1">
                            <p class="detail">{{ CONSTANT.RECRUITMENT_INFORMATION.duty }}</p>
                            <p class="detail mb-30">
                                {{ CONSTANT.RECRUITMENT_INFORMATION.duty_desc }}
                            </p>
                            <p class="detail">{{ CONSTANT.RECRUITMENT_INFORMATION.position_require }}</p>
                            <p
                                class="detail"
                                v-for="(item, index) in CONSTANT.RECRUITMENT_INFORMATION.require_list"
                                :key="index"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footer-wrap">{{ CONSTANT.COPY_RIGHT }}</div>
        </div>
    </div>
</template>

<script>
// import {
//     WELCOME_MSG,
//     MENU_DATA,
//     SCOPE_OF_SERVICES,
//     EXCEPTIONNAL_INDUSTRY_EXPERIENCE,
//     COMPANY_INFO,
//     TEAM_INFO,
//     ABOUT_US,
//     COMPANY_ADDRESS,
//     RECRUITMENT_INFORMATION,
// } from '../contants/index';
// import {
//     WELCOME_MSG,
//     MENU_DATA,
//     SCOPE_OF_SERVICES,
//     EXCEPTIONNAL_INDUSTRY_EXPERIENCE,
//     COMPANY_INFO,
//     TEAM_INFO,
//     ABOUT_US,
//     COMPANY_ADDRESS,
//     RECRUITMENT_INFORMATION,
// } from '../contants/index_en';
import axios from 'axios';
export default {
    name: 'HomeIndex',
    props: {
        msg: String,
    },
    components: {},
    data() {
        return {
            btns: [
                {
                    name: '中文',
                    key: 'zh',
                    active: true,
                },
                {
                    name: 'EN',
                    key: 'en',
                    active: false,
                },
            ],
            params: {
                name: '',
                email: '',
                mobile: '',
                desc: '',
            },
            CONSTANT: {},
            select_language: '',
            showArrowUp1: true,
            menuData: [],
            teamSwiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                freeMode: true,
                //分页器配置项
                pagination: {
                    el: '.swiper-pagination', //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                    type: 'bullets', //小圆点|进度条|数字页码
                },

                //滚动条
                scrollbar: true,

                //幻灯片播放配置项
                loop: true, //是否循环播放
                speed: 1000, // 发生页面切换动画时，动画的切换速度
                autoplay: {
                    delay: 2000, // 幻灯片停留时间
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        // 手动滑动后，轮播会停止，这里手动启动轮播
                        this.autoplay.start();
                        // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
                    },
                },
            },
            experienceSwiperOption: {
                slidesPerView: 1,
                //幻灯片播放配置项
                loop: true, //是否循环播放
                speed: 1000, // 发生页面切换动画时，动画的切换速度
                autoplay: {
                    delay: 4000, // 幻灯片停留时间
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        // 手动滑动后，轮播会停止，这里手动启动轮播
                        this.autoplay.start();
                        // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
                    },
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
    },
    created() {
        let select_language = window.localStorage.getItem('select_language');
        if (select_language) {
            this.btns.forEach((item) => {
                item.active = false;
            });
            this.btns.find((item) => item.key === select_language).active = true;
        }
        this.switchLanguage(select_language);
    },
    methods: {
        switchLanguage(select_language = 'zh') {
            this.select_language = select_language;
            if (select_language === 'en') {
                this.CONSTANT = require('../contants/index_en');
                this.menuData = JSON.parse(JSON.stringify(this.CONSTANT.MENU_DATA));
            } else {
                this.CONSTANT = require('../contants/index');
                this.menuData = JSON.parse(JSON.stringify(this.CONSTANT.MENU_DATA));
            }
        },
        btnClick(item) {
            this.btns.forEach((item) => {
                item.active = false;
            });
            item.active = true;
            this.switchLanguage(item.key);
            window.localStorage.setItem('select_language', item.key);
        },
        validateInput() {
            if (!this.params.name) {
                this.$message.error('请输入姓名');
                return false;
            }
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!this.params.email) {
                this.$message.error('请输入邮箱');
                return false;
            } else if (!emailRegex.test(this.params.email)) {
                this.$message.error('请输入正确的邮箱');
                return false;
            }
            if (!this.params.mobile) {
                this.$message.error('请输入联系方式');
                return false;
            } else if (!/^1[0-9]{10}$/.test(this.params.mobile)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            if (!this.params.desc) {
                this.$message.error('请输入内容');
                return false;
            }
            return true;
        },
        sendEmail() {
            if (!this.validateInput()) return;
            //  这里配置新的axios配置
            const $http = axios.create({
                baseURL: 'http://8.129.70.234:3000',
            });
            try {
                $http
                    .post('/api/sendEmail', {
                        name: this.params.name.trim(),
                        email: this.params.email.trim(),
                        mobile: this.params.mobile.trim(),
                        desc: this.params.desc.trim(),
                    })
                    .then(({ data }) => {
                        if (data.status === 200) {
                            this.resetParams();
                            this.$message.success('提交成功');
                        }
                    });
            } catch (error) {
                this.$message.error('提交未成功');
            }
        },
        resetParams() {
            this.params.name = '';
            this.params.email = '';
            this.params.mobile = '';
            this.params.desc = '';
        },
        onSlidePrev() {
            this.$refs.mySwiper2.$swiper.slidePrev();
        },
        onSlideNext() {
            this.$refs.mySwiper2.$swiper.slideNext();
        },
        handleClick(item) {
            this.menuData.forEach((x) => (x.active = false));
            item.active = true;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.index {
    min-width: 1380px;
    img {
        width: 100%;
        height: 100%;
    }
    .header {
        width: 100%;
        background: #134dab;
        .inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            height: 60px;
            line-height: 60px;
            margin: auto;
            color: #ffffff;
            .btn-wrap {
                display: flex;
                align-items: center;
                width: 132px;
                height: 40px;
                line-height: 40px;
                background: #1a3574;
                border-radius: 20px;
                padding: 0 2px;
                box-sizing: border-box;
                p {
                    margin: 0;
                    font-size: 16px;
                    width: 64px;
                    height: 36px;
                    border-radius: 20px;
                    background: #1a3574;
                    cursor: pointer;
                }
                .active {
                    background: #134dab;
                }
            }
        }
    }
    .menu {
        height: 130px;
        .logo {
            width: 174px;
            height: 54px;
            margin: 30px auto;
        }
        .menu-list {
            width: 588px;
            height: 46px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            
            .menu-item {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                cursor: pointer;
                a {
                    display: inline-block;
                    height: 40px;
                    line-height: 40px;
                    color: inherit;
                    text-decoration: none;
                    padding: 0 10px;
                }

                a:hover,
                a:visited,
                a:active {
                    color: inherit;
                    text-decoration: none;
                }
                a:hover {
                    background-color: #f3f3f3;
                }
            }
            .active {
                color: #134dab;
                &::after {
                    content: '';
                    display: block;
                    width: 32px;
                    height: 4px;
                    background: #134dab;
                    margin-top: 20px;
                }
            }
        }
        .menu-list_en {
            width: 800px;
        }
    }
    .banner {
        height: 554px;
        margin-top: 1px;
        background: #101b49 url('../assets/images/banner.png') no-repeat center;
        .banner-wrap {
            position: relative;
            width: 1100px;
            margin: auto;
            .content {
                height: 144px;
                font-weight: 300;
                font-size: 54px;
                color: #ffffff;
                line-height: 72px;
                text-align: left;
                position: absolute;
                left: 0;
                top: 203px;
            }
        }
    }
    .service-area {
        height: 819px;
        padding-top: 88px;
        box-sizing: border-box;
        .title {
            width: 462px;
            height: 63px;
            font-weight: 500;
            font-size: 44px;
            color: #333333;
            line-height: 58px;
            text-align: center;
            margin: 0 auto;
        }
        .content {
            width: 800px;
            height: 56px;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            line-height: 28px;
            text-align: center;
            margin: 15px auto 60px;
        }
        .service-sub {
            display: flex;
            width: 1140px;
            margin: 0 auto;
            justify-content: space-between;
            .sub-item {
                width: 360px;
                height: 450px;
                background: #f5f8f9;
                box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                cursor: pointer;
                padding: 10px;
                box-sizing: border-box;
                .item-icon {
                    width: 60px;
                    height: 60px;
                    margin: 75px auto 15px;
                }
                .item-title {
                    // width: 264px;
                    height: 38px;
                    margin: 0 auto;
                    font-weight: 500;
                    font-size: 32px;
                    color: #333333;
                    line-height: 38px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }
                .item-content {
                    margin-top: 19px;
                    p {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #666666;
                        line-height: 25px;
                        text-align: center;
                        font-style: normal;
                        text-transform: none;
                        margin: 0;
                    }
                }
                &:hover {
                    background: #134dab;
                    .item-title {
                        color: #ffffff;
                    }
                    .item-content {
                        p {
                            color: #ffffff;
                        }
                    }
                }
            }
            & :nth-child(1) {
                .item-icon {
                    background: url('../assets/images/service1.png') no-repeat;
                }
            }
            & :nth-child(1):hover {
                .item-icon {
                    background: url('../assets/images/service1-active.png') no-repeat;
                }
            }
            & :nth-child(2) {
                .item-icon {
                    background: url('../assets/images/service2.png') no-repeat;
                }
            }
            & :nth-child(2):hover {
                .item-icon {
                    background: url('../assets/images/service2-active.png') no-repeat;
                }
            }
            & :nth-child(3) {
                .item-icon {
                    background: url('../assets/images/service3.png') no-repeat;
                }
            }
            & :nth-child(3):hover {
                .item-icon {
                    background: url('../assets/images/service3-active.png') no-repeat;
                }
            }
        }
    }
    .experience-area {
        height: 1290px;
        padding-top: 88px;
        box-sizing: border-box;
        background-color: #f9f9f9;
        .title {
            width: 462px;
            height: 63px;
            font-weight: 500;
            font-size: 44px;
            color: #333333;
            line-height: 58px;
            text-align: center;
            margin: 0 auto;
        }
        .content {
            width: 800px;
            height: 56px;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            line-height: 28px;
            text-align: center;
            margin: 15px auto 60px;
        }
        .experience-sub {
            // display: flex;

            .company-wrap {
                display: flex;
                width: 1340px;
                height: 1000px;
                margin: auto;
                .left-btn,
                .right-btn {
                    display: flex;
                    align-items: center;
                    img {
                        position: relative;
                        top: -80px;
                        width: 72px;
                        height: 72px;
                    }
                }
                .left-btn {
                    padding-right: 25px;
                }
                .right-btn {
                    padding-left: 25px;
                }
                #mySwiper2 {
                    height: 100%;
                }
                .swiper-slide.swiper_slide_item {
                    display: flex;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    width: 1140px;
                    height: 100%;
                    background-color: #f9f9f9;

                    .com-item {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        width: 270px;
                        height: 466px;
                        margin-right: 20px;
                        .img {
                            width: 270px;
                            height: 270px;
                        }
                        .icon {
                            height: 44px;
                            width: 120px;
                            margin-top: 16px;
                        }
                        .com-name {
                            height: 30px;
                            font-weight: 600;
                            font-size: 24px;
                            color: #134dab;
                            line-height: 30px;
                            text-align: left;
                            margin: 12px 0;
                        }
                        .com-content {
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            letter-spacing: 1px;
                            text-align: left;
                            font-style: normal;
                        }
                    }
                    & > :nth-child(4),
                    & > :nth-child(8) {
                        margin-right: 0;
                    }
                }
            }
        }
    }
    .us-area {
        .us-wrap {
            display: flex;
            align-items: center;
            width: 1140px;
            margin: auto;
            padding: 88px;
            .left {
                width: 487px;
                height: 487px;
            }
            .right {
                width: 600px;
                margin-left: 54px;
                // padding-top: 30px;
                .title {
                    font-weight: 500;
                    font-size: 44px;
                    color: #333333;
                    line-height: 48px;
                    text-align: left;
                    margin-top: 0;
                    margin-bottom: 30px;
                }
                .content {
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    line-height: 28px;
                    text-align: left;
                    margin: 0;
                }
            }
        }
    }
    .team-area {
        height: 716px;
        padding-top: 88px;
        box-sizing: border-box;
        background-color: #f9f9f9;
        .title {
            width: 462px;
            height: 63px;
            font-weight: 500;
            font-size: 44px;
            color: #333333;
            line-height: 58px;
            text-align: center;
            margin: 0 auto;
            margin-bottom: 58px;
        }
        .team-wrap {
            #mySwiper {
                width: 100%;
                height: 448px;
                background-color: #f9f9f9;
            }
            .swiper-slide.swiper_slide_item {
                width: 640px;
                height: 350px;

                background: url('../assets/images/person-bg.png') no-repeat center;
                .slide-item-wrap {
                    height: 100%;
                    width: 100%;
                    padding: 40px 40px;
                    display: flex;
                    box-sizing: border-box;
                    .left {
                        img {
                            width: 240px;
                            height: 240px;
                        }
                    }
                    .right {
                        width: 320px;
                        box-sizing: border-box;
                        padding-top: 20px;
                        margin-left: 40px;
                        * {
                            margin: 0;
                        }
                        .name {
                            font-weight: 500;
                            font-size: 32px;
                            color: #333333;
                            text-align: left;
                            margin-bottom: 10px;
                        }
                        .desc {
                            &.desc2 {
                                margin-bottom: 10px;
                            }
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            text-align: left;
                            margin: 0;
                        }
                        .position {
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                            text-align: left;
                            margin: 0;
                        }
                    }
                }
            }
            #mySwiper /deep/ .swiper-pagination-bullet-custom.swiper-pagination-bullet {
                width: 15px !important;
                height: 15px !important;
                bottom: 0px !important;
            }
        }
    }
    .contact-area {
        background: url('../assets/images/contact-bg.png') no-repeat center;
        background-size: 100% 100%;
        .contact-wrap {
            display: flex;
            width: 1140px;
            margin: auto;
            padding: 120px;
            .left {
                width: 484px;
                .p-1,
                .p-2 {
                    font-weight: 500;
                    font-size: 44px;
                    color: #ffffff;
                    line-height: 58px;
                    text-align: left;
                }
                .p-3 {
                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 20px;
                    text-align: left;
                    margin-top: 16px;
                }
            }
            .right {
                width: 560px;
                margin-left: 96px;
                background: #ffffff;
                border-radius: 8px;
                padding: 40px;
                .form {
                    .btn {
                        width: 165px;
                        height: 42px;
                        line-height: 42px;
                        background: #134dab;
                        border-radius: 6px;
                        color: #ffffff;
                        font-size: 16px;
                        margin-top: 30px;
                        cursor: pointer;
                    }
                    .form-row {
                        display: flex;
                        .ml-20 {
                            margin-left: 20px;
                        }
                        .form-item {
                            .title {
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                line-height: 14px;
                                text-align: left;
                                font-weight: 400;
                            }
                            .input {
                                input {
                                    width: 240px;
                                    height: 42px;
                                    border-radius: 6px;
                                    border: 1px solid #c1c1c1;
                                    font-size: 16px;
                                    box-sizing: border-box;
                                    padding: 0 6px;
                                }
                                textarea {
                                    width: 504px;
                                    height: 111px;
                                    border-radius: 6px;
                                    border: 1px solid #c1c1c1;
                                    resize: none;
                                    font-size: 16px;
                                    box-sizing: border-box;
                                    padding: 6px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .hire-area {
        .hire-wrap {
            width: 1140px;
            margin: auto;
            padding: 88px;
            .title {
                width: 462px;
                line-height: 58px;
                font-size: 44px;
                color: #333333;
                line-height: 58px;
                text-align: center;
                margin: 0 auto;
            }
            .content {
                .item {
                    position: relative;
                    border-bottom: 1px solid #c1c1c1;
                    .name {
                        font-size: 36px;
                        color: #333333;
                        text-align: left;
                        margin-bottom: 10px;
                    }
                    .arrow {
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        width: 48px;
                        height: 48px;
                        cursor: pointer;
                        background: url('../assets/images/arrow-down.png') no-repeat;
                    }
                    .arrow-up {
                        background: url('../assets/images/arrow-up.png') no-repeat;
                    }
                    .desc {
                        font-size: 18px;
                        color: #666666;
                        line-height: 26px;
                        text-align: left;
                    }
                    .detail {
                        font-size: 16px;
                        color: #666666;
                        text-align: left;
                    }
                    .mb-30 {
                        margin-bottom: 30px;
                    }
                }
            }
        }
    }
    .footer {
        background: #161823;
        .footer-wrap {
            height: 105px;
            line-height: 105px;
            width: 1200px;
            margin: auto;
            color: rgba(255, 255, 255, 0.49);
            text-align: left;
            font-size: 16px;
        }
    }
}
</style>
